import { Link } from 'react-router-dom';

const footerLinks = {
  products: {
    title: '产品分类',
    links: [
      { label: '家居生活', path: '/category/home-living' },
      { label: '个人护理', path: '/category/personal-care' },
      { label: '运动户外', path: '/category/outdoor-sports' },
      { label: '数码配件', path: '/category/digital-accessories' },
      { label: '厨房用品', path: '/category/kitchen' },
    ],
  },
  company: {
    title: '关于久久久',
    links: [
      { label: '品牌介绍', path: '/about#brand' },
      { label: '品质口碑', path: '/about#testimonials' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  articles: {
    title: '文章中心',
    links: [
      { label: '选购指南', path: '/article/how-to-choose-durable-products' },
      { label: '保养技巧', path: '/article/daily-maintenance-tips' },
      { label: '品质生活', path: '/article/quality-life-philosophy' },
    ],
  },
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="font-heading text-xl font-semibold text-foreground-950" aria-label="久久久首页">
              久久久
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              持久稳定的品质体验<br />经久不衰的信赖之选
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 久久久 版权所有
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-foreground-500">服务热线：400-888-9999</span>
            <span className="text-xs text-foreground-500">service@jiujiujiu.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}